import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: attendance.MovementCode.
export default class MovementCode extends Model {
  declare [Type]: 'attendance/movement-code';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr({ defaultValue: () => ({}) })
  declare counts: Record<string, number>;
}
